import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';

const CATEGORIES = ['customer','tradeshow','partner','sustainability','product','recipe','lifestyle','quote','education','other'];

export default function AddIdeaModal({ onClose, editIdea }) {
  const { addIdea, updateIdea, currentUser, logActivity } = useApp();
  const [title,    setTitle]    = useState(editIdea?.title    || '');
  const [notes,    setNotes]    = useState(editIdea?.notes    || '');
  const [customer, setCustomer] = useState(editIdea?.customer || '');
  const [category, setCategory] = useState(editIdea?.category || 'other');
  const [urgency,  setUrgency]  = useState(editIdea?.urgency  || 'anytime');
  const [world,    setWorld]    = useState(editIdea?.world    || null);
  const [saving,   setSaving]   = useState(false);
  const [error,    setError]    = useState('');

  async function submit() {
    if (!title.trim()) return;
    setSaving(true);
    setError('');
    try {
      const payload = {
        source:       'staff',
        title:        title.trim(),
        notes:        notes.trim(),
        customer:     customer.trim(),
        category,
        world,
        urgency,
        status:       'new',
        submitted_by: currentUser?.id,
        who:          currentUser?.name,
      };
      if (editIdea) {
        await updateIdea(editIdea.id, payload);
      } else {
        await addIdea(payload);
      }
      logActivity(editIdea ? 'Updated idea' : 'Submitted idea', title.trim());
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to save idea.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-ov" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-box">
        <div className="modal-head">
          <div className="modal-title">{editIdea ? 'Edit Idea' : '💡 New Idea'}</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          <div className="f-row">
            <div className="f-lbl">Idea title *</div>
            <input className="f-inp" value={title} onChange={e => setTitle(e.target.value)}
              placeholder="What's the content idea?" autoFocus />
          </div>
          <div className="f-row">
            <div className="f-lbl">Notes / context</div>
            <textarea className="f-ta" rows={3} value={notes} onChange={e => setNotes(e.target.value)}
              placeholder="Extra details, links, context..." />
          </div>
          <div className="f-g2">
            <div>
              <div className="f-lbl">Customer / company (optional)</div>
              <input className="f-inp" value={customer} onChange={e => setCustomer(e.target.value)} placeholder="e.g. Marriott" />
            </div>
            <div>
              <div className="f-lbl">Category</div>
              <select className="f-sel" value={category} onChange={e => setCategory(e.target.value)}>
                {CATEGORIES.map(c => <option key={c} value={c}>{c.charAt(0).toUpperCase() + c.slice(1)}</option>)}
              </select>
            </div>
          </div>
          <div className="f-row">
            <div className="f-lbl">Urgency</div>
            <div className="urg-row">
              {[['hot','🔥 Hot'],['soon','⏰ Soon'],['anytime','🌿 Anytime']].map(([u, label]) => (
                <button key={u} className={`urg-btn ${urgency === u ? 'on' : ''}`} onClick={() => setUrgency(u)}>{label}</button>
              ))}
            </div>
          </div>
          <div className="f-row">
            <div className="f-lbl">Audience world</div>
            <div style={{ display:'flex', gap:6 }}>
              {[[null,'Both'],['business','Business'],['consumer','Consumer']].map(([w, label]) => (
                <button key={String(w)} className={`btn btn-sm ${world === w ? 'btn-primary' : 'btn-outline'}`}
                  onClick={() => setWorld(w)}>{label}</button>
              ))}
            </div>
          </div>
          {error && <div className="err-bar">{error}</div>}
          <div style={{ display:'flex', justifyContent:'flex-end', gap:8, marginTop:8 }}>
            <button className="btn btn-outline" onClick={onClose}>Cancel</button>
            <button className="btn btn-primary" onClick={submit} disabled={!title.trim() || saving}>
              {saving ? <>Saving <span className="dots"><i/><i/><i/></span></> : (editIdea ? 'Save Changes' : 'Submit Idea')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
